import { render, staticRenderFns } from "./Copiar_Formato_OtroPeriodo_FormatoConvenio.vue?vue&type=template&id=2c564005&scoped=true"
import script from "./Copiar_Formato_OtroPeriodo_FormatoConvenio.vue?vue&type=script&lang=js"
export * from "./Copiar_Formato_OtroPeriodo_FormatoConvenio.vue?vue&type=script&lang=js"
import style0 from "./Copiar_Formato_OtroPeriodo_FormatoConvenio.vue?vue&type=style&index=0&id=2c564005&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c564005",
  null
  
)

export default component.exports